import {
  InitialState,
  VendorState,
  VendorActions,
  GET_VENDOR_ID,
  GET_VENDOR_ID_SUCCEEDED,
  GET_VENDOR_ID_ERROR,
  GET_VENDOR_ID_RESET,
} from './types'
import { status } from '../../typeStatus'

const VendorReducer = (state: VendorState = InitialState, action: VendorActions): VendorState => {
  switch (action.type) {
    case GET_VENDOR_ID_RESET: {
      return {
        ...state,
        vendorId: null,
      }
    }
    case GET_VENDOR_ID: {
      return {
        ...state,
        vendorIdStatus: status.loading,
        vendorId: null,
      }
    }
    case GET_VENDOR_ID_SUCCEEDED: {
      return {
        ...state,
        vendorIdStatus: status.success,
        vendorId: action.payload,
      }
    }
    case GET_VENDOR_ID_ERROR: {
      return {
        ...state,
        vendorId: null,
        vendorIdStatus: status.error,
      }
    }

    default:
      return state
  }
}

export default VendorReducer
